import Profile from "../pages/company/Profile";
import Users from "../pages/user/Users";
import SignUp from "../pages/auth/SignUp";
import SignIn from "../pages/auth/SignIn";
import ForgotPassword from "../pages/auth/ForgotPassword";
import SendOtp from "../pages/auth/SendOtp";
import NewPassword from "../pages/auth/NewPassword";
import Billing from "../pages/billing/Billing";
import CheckYouEmail from "../pages/auth/CheckYourEmail";
import BackToDashboard from "../pages/auth/BackToDashboard";
import ClientRequestList from "../pages/clients/ClientRequestList";
import ClientList from "../pages/clients/ClientList";
import dashboardIcon from "../../src/assets/icons/dashboad.svg";
import moneyIcon from "../../src/assets/icons/money.svg";
import userIcon from "../../src/assets/icons/User.svg";
import twoUser from "../../src/assets/icons/profile-2user.svg";
import kontenIcon from "../../src/assets/icons/Konten.svg";
import SettingsIcon from "../../src/assets/icons/user-edit.svg";
import BillingIcon from "../../src/assets/icons/wallet-2.svg";
import RequireAuth from "./RequireAuth.jsx";
import UserProfile from "../pages/profile/UserProfile.jsx";
import ClientPaymentStatus from "../pages/clients/ClientPaymentStatus.jsx";
import CustomerUsers from "../pages/customer/user/Users.jsx";
import ExpireInvitation from "../pages/auth/InvitationExpire.jsx";
import ClientDashboard from "../pages/customer/dashboard/Dashboard.jsx";
import AdminDashboard from "../pages/admin/dashboard/Dashboard.jsx";
import Konten from "../pages/customer/konten/Konten.jsx";
import Umsatxplanung from "../pages/customer/umsatzplanung/Umsatxplanung.jsx";
import UmsatxplanungAdmin from "../pages/admin/umsatzplanung/Umsatxplanung.jsx";
import PaymentHistory from "../pages/billing/payment-history/Index.jsx";
import Stammdaten from "../pages/customer/stammdaten/Stammdaten.jsx";
import CustomerProfile from "../pages/customer/profile/UserProfile.jsx";
import CustomerCompany from "../pages/customer/company/CustomerCompany.jsx";
import SelectCustomerStammdaten from "../pages/admin/stammdaten/Stammdaten.jsx";
import SelectCustomerKonten from "../pages/admin/konten/Konten.jsx";
import Forderungen from "../pages/customer/forderungen/Forderungen.jsx";
import ForderungenAdmin from "../pages/admin/forderungen/Forderungen.jsx";
import Verbindlichkeiten from "../pages/customer/verbindlichkeiten/Verbindlichkeiten.jsx";
import VerbindlichkeitenAdmin from "../pages/admin/verbindlichkeiten/Verbindlichkeiten.jsx";
import Liquiditätsbilanz from "../pages/customer/liquiditätsbilanz/Liquiditätsbilanz.jsx";
import LiquiditätsbilanzAdmin from "../pages/admin/liquiditätsbilanz/Liquiditätsbilanz.jsx";
import CustomerIntegration from "../pages/customer/integrations/CustomerIntegration.jsx";
import WisoCallback from "../pages/customer/integrations/WisoCallback.jsx";
import FinanceRecommendationsPage from "../pages/customer/financeRecommendation/FinanceRecommendation.jsx";

export const privateAdminRoutes = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: dashboardIcon,
    element: (
      <RequireAuth>
        <AdminDashboard />
      </RequireAuth>
    ),
    translationKey: "module_dashboard"
  },
  {
    label: "Konten",
    to: "/konten",
    icon: kontenIcon,
    element: (
      <RequireAuth>
        <SelectCustomerKonten />
      </RequireAuth>
    ),
    translationKey: "module_konten"
  },
  {
    label: "Umsatzplanung",
    to: "/umsatzplanung",
    icon: kontenIcon,
    element: (
      <RequireAuth>
        <UmsatxplanungAdmin />
      </RequireAuth>
    ),
    translationKey: "module_umasatzplanung"
  },
  {
    label: "Forderungen",
    to: "/forderungen",
    icon: kontenIcon,
    element: (
      <RequireAuth>
        <ForderungenAdmin />
      </RequireAuth>
    ),
    translationKey: "module_forderungen"
  },
  {
    label: "Verbindlichkeiten",
    to: "/verbindlichkeiten",
    icon: moneyIcon,
    element: (
      <RequireAuth>
        <VerbindlichkeitenAdmin />
      </RequireAuth>
    ),
    translationKey: "module_verbindlichkeiten"
  },
  {
    label: "Liquiditätsbilanz",
    to: "/liquiditätsbilanz",
    icon: moneyIcon,
    element: (
      <RequireAuth>
        <LiquiditätsbilanzAdmin />
      </RequireAuth>
    ),
    translationKey: "module_liquiditätsbilanz"
  },
  {
    label: "Finanzierungsmöglichkeiten",
    to: "/financerecommendations",
    icon: moneyIcon,
    element: (
      <RequireAuth>
        <FinanceRecommendationsPage />
      </RequireAuth>
    ),
    translationKey: "module_financerecommendation"
  },
  {
    label: "Stammdaten",
    to: "/stammdaten",
    icon: twoUser,
    element: (
      <RequireAuth>
        <SelectCustomerStammdaten />
      </RequireAuth>
    ),
    translationKey: "Stammdaten"
  },
  {
    label: "Profile Settings",
    to: "/profile",
    icon: kontenIcon,
    isNotNavmanu: true,
    element: (
      <RequireAuth>
        <UserProfile />
      </RequireAuth>
    ),
    translationKey: "module_profile_settings"
  },
];

export const privateCustomerRoute = [
  {
    label: "Dashboard",
    to: "/dashboard",
    icon: dashboardIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <ClientDashboard />
      </RequireAuth>
    ),
    translationKey: "module_dashboard"
  },
  {
    label: "Konten",
    to: "/konten",
    icon: kontenIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <Konten />
      </RequireAuth>
    ),
    translationKey: "module_konten"
  },
  {
    label: "Umsatzplanung",
    to: "/umsatzplanung",
    icon: kontenIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <Umsatxplanung />
      </RequireAuth>
    ),
    translationKey: "module_umasatzplanung"
  },
  {
    label: "Forderungen",
    to: "/forderungen",
    icon: kontenIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <Forderungen />
      </RequireAuth>
    ),
    translationKey: "module_forderungen"
  },
  {
    label: "Verbindlichkeiten",
    to: "/verbindlichkeiten",
    icon: moneyIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <Verbindlichkeiten />
      </RequireAuth>
    ),
    translationKey: "module_verbindlichkeiten"
  },
  {
    label: "Liquiditätsbilanz",
    to: "/liquiditätsbilanz",
    icon: kontenIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <Liquiditätsbilanz />
      </RequireAuth>
    ),
    translationKey: "module_liquiditätsbilanz"
  },
  {
    label: "Finanzierungsmöglichkeiten",
    to: "/financerecommendations",
    icon: moneyIcon,
    element: (
      <RequireAuth>
        <FinanceRecommendationsPage />
      </RequireAuth>
    ),
    translationKey: "module_financerecommendation"
  },
  {
    label: "Stammdaten",
    to: "/stammdaten",
    icon: twoUser,
    element: (
      <RequireAuth isCustomer={true}>
        <Stammdaten />
      </RequireAuth>
    ),
    translationKey: "Stammdaten"
  },
  {
    label: "Profile Settings",
    to: "/settings/profile",
    icon: kontenIcon,
    isNotNavmanu: true,
    element: (
      <RequireAuth isCustomer={true}>
        <CustomerProfile />
      </RequireAuth>
    ),
    translationKey: "module_profile_settings"
  },
  {
    label: "Settings",
    to: "/settings",
    icon: SettingsIcon,
    translationKey: "module_payment_settings",
    children: [

      {
        label: "Company Details",
        to: "/settings/company",
        icon: kontenIcon,
        element: (
          <RequireAuth isCustomer={true}>
            <CustomerCompany />
          </RequireAuth>
        ),
        translationKey: "module_company_details"
      },
      {
        label: "Integrations",
        to: "/settings/integrations",
        icon: kontenIcon,
        element: (
          <RequireAuth isCustomer={true}>
            <CustomerIntegration />
          </RequireAuth>
        ),
        translationKey: "module_integrations"
      },
      {
        label: "WISO Callback",
        to: "/settings/integrations/wiso/callback",
        icon: kontenIcon,
        isNotNavmanu: true,
        element: (
          <RequireAuth isCustomer={true}>
            <WisoCallback />
          </RequireAuth>
        ),
        tranlationKey: "module_wiso_integration"
      }
    ],
  },
  {
    label: "User Management",
    to: "/customer/users",
    icon: userIcon,
    element: (
      <RequireAuth isCustomer={true}>
        <CustomerUsers />
      </RequireAuth>
    ),
    translationKey: "module_user_management"
  },
  {
    label: "Billing",
    to: "/billing",
    icon: BillingIcon,
    translationKey: "module_billing",
    children: [
      {
        label: "Billing Plans",
        to: "/billing/plans",
        element: (
          <RequireAuth isCustomer={true}>
            <Billing />
          </RequireAuth>
        ),
        translationKey: "module_payment_billing_plan"
      },
      {
        label: "Payment History",
        to: "/billing/paymentHistory",
        element: (
          <RequireAuth isCustomer={true}>
            <PaymentHistory />
          </RequireAuth>
        ),
        translationKey: "payment_history"
      }
    ],
  },
];

export const adminRoutes = [
  {
    label: "User Management",
    to: "/user",
    icon: userIcon,
    element: (
      <RequireAuth>
        <Users />
      </RequireAuth>
    ),
    translationKey: "module_user_management"
  },
  {
    label: "Clients",
    to: "/clients",
    icon: twoUser,
    translationKey: "module_clients",
    // element: <Client />,
    children: [
      {
        label: "Client List",
        to: "/clients/list",
        element: (
          <RequireAuth>
            <ClientList />
          </RequireAuth>
        ),
        translationKey: "module_client_list"
      },
      {
        label: "Approval List",
        to: "/clients/approvalList",
        element: (
          <RequireAuth>
            <ClientRequestList />
          </RequireAuth>
        ),
        translationKey: "module_client_approval_list"
      },
      {
        label: "Payment Status",
        to: "/clients/ClientPaymentStatus",
        element: (
          <RequireAuth>
            <ClientPaymentStatus />
          </RequireAuth>
        ),
        translationKey: "module_payment_status"
      },
    ],
  },
  {
    label: "Company Details",
    to: "/companyDetails",
    icon: kontenIcon,
    element: (
      <RequireAuth>
        <Profile />
      </RequireAuth>
    ),
    translationKey: "module_company_details"
  },
];

export const authRoutes = [
  {
    label: "Sign Up",
    to: "/signUp",
    element: <SignUp />,
  },
  {
    label: "Sign In",
    to: "/signIn",
    element: <SignIn />,
  },
  {
    label: "Forgot Password",
    to: "/forgot-password",
    element: <ForgotPassword />,
  },
  {
    label: "Send Mail",
    to: "/send-mail/:email",
    element: <SendOtp />,
  },
  {
    label: "check your email",
    to: "/check-your-email/:email",
    element: <CheckYouEmail />,
  },
  {
    label: "check your email",
    to: "/verify-email/:email/:token",
    element: <BackToDashboard />,
  },
  {
    label: "New Password",
    to: "/new-password/:token",
    element: <NewPassword />,
  },
  {
    label: "Expire Invitation",
    to: "/expire-invitation",
    element: <ExpireInvitation />,
  },
];
